import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { DOCUMENT, inject, PLATFORM_ID } from '@angular/core';

import { map, Observable, of, tap } from 'rxjs';

import { CookieManagerResponse, Status } from './cookie-manager.interface';

export abstract class CookieBaseService {
	protected readonly platformId = inject(PLATFORM_ID);
	protected readonly document = inject<Document>(DOCUMENT);
	protected readonly http = inject(HttpClient);

	protected abstract getCookieServiceUrl(): string;

	setCookie(
		cookieName: string,
		cookieValue: Status,
	): Observable<CookieManagerResponse> {
		if (isPlatformBrowser(this.platformId)) {
			const url = new URL(this.getCookieServiceUrl());
			url.searchParams.append('setCookieName', cookieName);
			url.searchParams.append('setCookieValue', cookieValue);
			this.setLocalCookie(cookieName, cookieValue);

			return this.http.jsonp<CookieManagerResponse>(
				url.toString(),
				'callback',
			);
		}
		return of({ succes: true, cookiestatus: Status.ACCEPTED });
	}

	getCookie(cookieName: string): Observable<Status> {
		if (isPlatformBrowser(this.platformId)) {
			const url = new URL(this.getCookieServiceUrl());
			url.searchParams.append('getCookie', cookieName);
			return this.http
				.jsonp<CookieManagerResponse>(url.toString(), 'callback')
				.pipe(
					tap((response) => {
						if (response.cookiestatus !== Status.EMPTY) {
							this.setLocalCookie(
								cookieName,
								response.cookiestatus,
							);
						}
					}),
					map((response) => {
						return response.cookiestatus;
					}),
				);
		}
		return of(Status.ACCEPTED);
	}

	getLocalCookie(name: string): boolean {
		if (isPlatformBrowser(this.platformId)) {
			const regex = new RegExp(`(^| )${name}=([^;]+)`);
			const match = regex.exec(this.document.cookie);
			return !!match;
		}
		return false;
	}

	getLocalCookieValueAsBoolean(name: string): boolean {
		if (isPlatformBrowser(this.platformId)) {
			const regex = new RegExp(`(^| )${name}=([^;]+)`);
			const match = regex.exec(this.document.cookie);
			if (match) return match[2] === Status.ACCEPTED;
		}
		return false;
	}

	private setLocalCookie(cookieName: string, cookieValue: Status): void {
		/* istanbul ignore else */
		if (isPlatformBrowser(this.platformId)) {
			this.document.cookie = `${cookieName}=${cookieValue}`;
		}
	}
}
